import React from 'react';
import { format } from 'date-fns';
import { ConflictDetail } from '@/types/recommendation';
import { AlertCircle } from 'lucide-react';

interface ConflictSummaryAlertProps {
  conflictDetails: ConflictDetail;
}

export function ConflictSummaryAlert({ conflictDetails }: ConflictSummaryAlertProps) {
  return (
    <div className="flex items-start gap-2.5 rounded-md border border-destructive/20 bg-destructive/8 px-3 py-2.5 text-sm">
      <AlertCircle className="h-4 w-4 text-destructive shrink-0 mt-0.5" />
      <div className="min-w-0">
        <span className="font-semibold text-destructive">
          {conflictDetails.conflictingProjectName}
        </span>
        <span className="text-muted-foreground ml-1.5">
          allocated {conflictDetails.allocationPercent}%
          {' '}·{' '}
          {format(new Date(conflictDetails.overlapStart), 'dd MMM')}
          {' – '}
          {format(new Date(conflictDetails.overlapEnd), 'dd MMM')}
        </span>
      </div>
    </div>
  );
}
